module.exports = __webpack_public_path__ + "static/img/book-5.874bf40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/book-5.png
// module id = zKq7
// module chunks = 10